import styled from 'styled-components'
import themeAsseticonVideoVipPng from '@theme/icon-video/vip.png'

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 0.87rem;
  height: 0.61rem;
  line-height: 0.56rem;
  background-image: url('${themeAsseticonVideoVipPng}');
  background-size: 100% 100%;
`
